/* =============================================================================
   ZEPHIR — mega menu: despertar las imagenes del panel (2026-09-03)
   =============================================================================
   HISTORIA DEL ARCHIVO, porque el nombre ya no describe lo que hace:
   nacio como una vista previa reactiva -- al pasar por una subcategoria pedia
   `/collections/<handle>/products.json` y pintaba tres prendas con foto, nombre
   y descripcion. El cliente prefirio UNA imagen grande que sube el mismo, asi
   que ese hueco lo ocupa ahora un bloque `banner` del tema y toda esa maquinaria
   se retiro. Se conserva el nombre del archivo para no tocar
   sections/zephir-fonts.liquid ni el resto de referencias.

   QUEDA UNA COSA QUE SI HACE FALTA. Las fotos de los paneles (los azulejos de
   coleccion y las imagenes grandes) usan el lazyload del tema -- `data-src` mas
   `data-sizes="auto"` --, que no arranca hasta que el elemento esta en pantalla.
   Como el panel esta oculto hasta el hover, en el primer hover se veian los
   marcos planos un instante. Aqui se fuerza la carga al abrirse el panel.

   DOS DETALLES QUE NO SON OPCIONALES:
   - El `data-src` del tema se genera con `image_url: width: 1`: es una imagen de
     UN pixel. Copiarlo a `src` pintaria un borron, hay que sustituir el
     `width=1` por un ancho real. Se lee de `dataset`, ya decodificado, que es
     donde estaba la trampa de los `&amp;` que Shopify ignora.
   - El panel se inyecta con innerHTML y TARDE (al primer hover, y cacheado en
     sessionStorage), asi que no se pueden enganchar listeners a sus elementos:
     se escucha en `document` y se resuelve en el momento. Y se escuchan
     `pointerover` Y `mouseover`, porque no todos los emisores producen el
     primero.
   ========================================================================== */
(function () {
  'use strict';

  // Por debajo de 1025 px no hay mega menu (el cajon de movil usa su propio
  // arbol), asi que no hay nada que despertar.
  function enEscritorio() {
    return !window.matchMedia || window.matchMedia('(min-width: 1025px)').matches;
  }

  function despertar(panel) {
    if (!panel) return;
    // Lo limpio primero: pedirle al lazyload del tema que repase.
    if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) {
      window.lazySizes.loader.checkElems();
    }
    panel.querySelectorAll('img[data-src]').forEach(function (img) {
      var actual = img.getAttribute('src') || '';
      if (actual.indexOf('data:') !== 0) return;        // ya tiene foto de verdad
      var url = img.dataset.src || '';
      if (!url) return;
      img.src = url.replace(/([?&])width=1(?=&|$)/, '$1width=900');
    });
  }

  function alEntrar(e) {
    if (!enEscritorio()) return;
    if (!e.target || !e.target.closest) return;         // el objetivo puede no ser un elemento
    var li = e.target.closest('li.t4s-type__mega');
    if (!li) return;
    despertar(li.querySelector('.t4s-sub-menu'));
  }

  ['pointerover', 'mouseover'].forEach(function (ev) {
    document.addEventListener(ev, alEntrar, true);
  });

  function repasar() {
    if (!enEscritorio()) return;
    document.querySelectorAll('#t4s-nav-ul .t4s-sub-menu').forEach(despertar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repasar);
  } else {
    repasar();
  }

  // Y de nuevo cuando el tema inyecta los paneles. El observador se DEBOUNCEA:
  // sin eso se dispara cientos de veces por el carrusel del inicio y los
  // scripts de terceros, y cada disparo barreria el DOM.
  var pendiente = null;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = setTimeout(function () { pendiente = null; repasar(); }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
